import { render, staticRenderFns } from "./DocumentationsContent.vue?vue&type=template&id=48a9cabd&scoped=true&"
import script from "./DocumentationsContent.vue?vue&type=script&lang=js&"
export * from "./DocumentationsContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationsContent.vue?vue&type=style&index=0&id=48a9cabd&lang=scss&scoped=true&"
import style1 from "./DocumentationsContent.vue?vue&type=style&index=1&id=48a9cabd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9cabd",
  null
  
)

export default component.exports